class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerSectionHtml = parsedState?.sections?.['cart-drawer'];

    /*
     * Neste tema, o estado vazio fica no próprio <cart-drawer> e também em
     * <cart-drawer-items>. O código anterior tentava remover "is-empty" de
     * .drawer__inner, elemento que nunca recebe essa classe.
     *
     * Resultado: depois de adicionar o kit, o HTML novo era inserido, mas o
     * drawer continuava com o estado visual de carrinho vazio, deixando a
     * parte superior branca e o conteúdo fora do layout esperado.
     */
    if (drawerSectionHtml) {
      const drawerDocument = new DOMParser().parseFromString(drawerSectionHtml, 'text/html');
      const sourceDrawer = drawerDocument.querySelector('cart-drawer');

      if (sourceDrawer) {
        this.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
      } else if (typeof parsedState?.item_count === 'number') {
        this.classList.toggle('is-empty', parsedState.item_count === 0);
      }
    } else if (typeof parsedState?.item_count === 'number') {
      this.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    this.productId = parsedState?.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState?.sections?.[section.id];
      if (!sectionHtml) return;

      const sectionElement =
        section.id === 'cart-drawer' && section.selector
          ? this.querySelector(section.selector)
          : section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

      if (!sectionElement) return;

      const nextInnerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (nextInnerHTML == null) return;

      /*
       * Mantém o nó externo de #cart-icon-bubble para não perder o listener
       * de acessibilidade criado no construtor. No drawer, apenas o conteúdo
       * interno de #CartDrawer é atualizado, seguindo o fluxo nativo do tema.
       */
      sectionElement.innerHTML = nextInnerHTML;
    });

    window.requestAnimationFrame(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');

      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }

      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;

    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return element ? element.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
